<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-car"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">{{'OFFER_CONFIG.COMMUNICATION' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.POLICY_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.TYPE_OF_POLICY' | translate">
                                {{ (product.configuration.continuation.selected ? 'CALCULATION_SUBJECT.CONTINUATION' : 'CALCULATION_SUBJECT.NEW_POLICY') | translate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="continuation === calculationSubject.CONTINUATION">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.LAST_YEAR_POLICY_NR' | translate">
                                {{ product.configuration.continuation.policyNumber}}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'INSURANCE_PERIOD' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-4">

                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
                                {{ product.configuration.insuranceStartDate }}
                            </app-output>
                        </div>
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_TO' | translate">
                                {{ product.configuration.insuranceEndDate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'MOTOR_CONFIG.INSURED_DATA' | translate }}</h3>

                    <ng-container *ngFor="let driver of product.configuration.driverList; let index = index">
                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.INSURED_NAME_PESEL' | translate">
                                    {{ product.parties[driver.partyId].fullName }}, {{ product.parties[driver.partyId].pesel }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4" *ngIf="!product.configuration.driverList[index].noLicense">
                                <app-output [label]="'MOTOR_CONFIG.DRIVING_LICENSE_DATE' | translate">
                                    {{ product.configuration.driverList[index].licenseDate }}
                                </app-output>
                            </div>
                            <div class="col-4" *ngIf="product.configuration.driverList[index].noLicense">
                                <app-output [label]="'MOTOR_CONFIG.DRIVING_LICENSE_DATE' | translate">
                                    {{ 'MOTOR_CONFIG.NO_DRIVING_LICENSE' | translate }}
                                </app-output>
                            </div>
                        </div>
                    </ng-container>


                    <div class="separator"></div>


                    <ng-container
                            *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.EUROTAX">
                        <h3 class="page-subheader">{{'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate}}</h3>

                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.categoryDescription }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate">
                                    {{ product.configuration.vehicleDefinition.productionYear }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAKE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.makeDescription }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MODEL' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.modelDescription }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.BODY_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.bodyTypeItem?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.doorCount }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.fuelTypeItem.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.capacity | suffixLabel : 'LABEL.SUFFIX_CM3'}}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.TRANSMISSION' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.gearBoxTypeItem.description }}
                                </app-output>
                            </div>
                        </div>
                    </ng-container>


                    <ng-container *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.MANUAL">
                        <h3 class="page-subheader">{{'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate}}</h3>

                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.type?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate">
                                    {{ product.configuration.vehicleDefinition.productionYear }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAKE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.make }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MODEL' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.model }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.BODY_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.bodyType?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.doors?.description }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.fuelType?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.VERSION' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.version }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.engineCapacity | suffixLabel : 'LABEL.SUFFIX_CM3' }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.KW' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.enginePower | suffixLabel : 'LABEL.SUFFIX_KW' }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.LOAD_CAPACITY' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.loadCapacity | suffixLabel : 'LABEL.SUFFIX_KG' }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAXIMUM_WEIGHT' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.maximumWeight | suffixLabel : 'LABEL.SUFFIX_KG' }}
                                </app-output>
                            </div>
                        </div>
                    </ng-container>


                    <div class="row form-row">
                        <div class="col-4">

                            <app-output [label]="'MOTOR_CONFIG.MILEAGE' | translate">
                                {{ product.configuration.vehicleDefinition.mileage }}
                            </app-output>
                        </div>

                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.FIRST_REGISTRATION_DATE' | translate">
                                {{ product.configuration.vehicleDefinition.firstRegistrationDate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.REGISTRATION_NUMBER' | translate">
                                {{ product.configuration.vehicleDefinition.licensePlate }}
                            </app-output>
                        </div>

                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.VIN' | translate">
                                {{ product.configuration.vehicleDefinition.vin }}
                            </app-output>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.MOTOR_VALUE' | translate">
                                {{ product.configuration.vehicleDefinition.vehicleValue | premium }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'MOTOR_CONFIG.VEHICLE_DETAILS' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-6 form-label-static">
                            <app-output [label]="'MOTOR_CONFIG.RIGHT_STEERING_WHEEL' | translate">
                                {{ product.configuration.vehicleDefinition.steeringWheelRightSide | yesNo | translate }}
                            </app-output>
                        </div>
                        <div class="col-6 form-label-static"
                             *ngIf="product.configuration.vehicleDefinition.vehicleUnusualUsage.usageList.length > 0">
                            <app-output [label]="'MOTOR_CONFIG.UNUSUAL' | translate">
                                {{ product.configuration.vehicleDefinition.vehicleUnusualUsage.usageList | joinDescriptions }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <ng-container *ngIf="product.configuration.leasing.selected">
                        <h3 class="page-subheader">{{ 'MOTOR_CONFIG.LEASING' | translate }}</h3>

                        <div class="row form-row">
                            <div class="col-6">
                                <app-output [label]="'MOTOR_CONFIG.LESSER_NAME' | translate">
                                    {{ product.configuration.leasing.name }}
                                </app-output>
                            </div>
                            <div class="col-6">
                                <app-output [label]="'MOTOR_CONFIG.LESSER_ADDRESS' | translate">
                                    {{ product.configuration.leasing.address.fullAddress }}
                                </app-output>
                            </div>
                        </div>

                        <div class="separator"></div>

                    </ng-container>
                </div>
            </div>


            <div class="section">
                <div class="section-content">

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'MOTOR_CONFIG.CLAIMS_HISTORY' | translate}}</h3>

                    <ng-container *ngFor="let driver of product.configuration.driverList; let index = index">

                        <ng-container *ngIf="index > 0">
                            <hr>
                            <div class="separator"></div>
                        </ng-container>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.INSURED_NAME_PESEL' | translate">
                                    {{ product.parties[driver.partyId].fullName }}, {{ product.parties[driver.partyId].pesel }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4"></div>
                            <div class="col-3">{{ 'LABEL.OC' | translate }}</div>
                            <div class="col-3">{{ 'LABEL.AC' | translate }}</div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.INSURANCE_COUNTINUITY' | translate}}
                            </div>

                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.thirdPartyLiability.continuityYears }}
                            </div>
                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.autocasco.continuityYears }}
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.CLAIMS_2YEARS' | translate}}
                            </div>
                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.thirdPartyLiability.claims2y }}
                            </div>
                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.autocasco.claims2y }}
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.CLAIMS_5YEARS' | translate}}
                            </div>
                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.thirdPartyLiability.claims5y }}
                            </div>
                            <div class="col-3 form-label-static-sm">
                                {{ driver.insuranceClaimHistory.autocasco.claims5y }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="section">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'OFFER_CONFIG.INSURANCE_COVERAGE' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-6"></div>
                        <div class="col-3">{{ 'MOTOR_CONFIG.SUM_OF_INSURANCE' | translate }}</div>
                        <div class="col-3 text-right">{{ 'OFFER_CONFIG.PREMIUM' | translate }}</div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.thirdPartyLiability.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.INSURANCE_SCOPE_OC' | translate }}
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.ACCORDING_TO_LAW' | translate }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            {{ product.configuration.thirdPartyLiability.premium | premium }}
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.autocasco.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.INSURANCE_SCOPE_AC' | translate }}
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ product.configuration.autocasco.sumOfInsurance | premium }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            {{ product.configuration.autocasco.premium | premium }}
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.autocasco.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.DAMAGE_LIQUIDATION' | translate }}
                        </div>

                        <div class="col-6">
                            <app-output>
                                {{ product.configuration.autocasco.claimSettlementMode?.description }}
                            </app-output>
                        </div>
                    </div>

                    <hr/>

                    <div class="row form-row" *ngIf="product.configuration.accidentInsurance.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.ADDON_NNW' | translate }}
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ product.configuration.accidentInsurance.sumOfInsurance | premium }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            <span>{{ product.configuration.accidentInsurance.premium | premium }}</span>
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.motorAssistance.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.ADDON_ASSSTANCE' | translate }}
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ product.configuration.motorAssistance.sumOfInsurance | premium }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            {{ product.configuration.motorAssistance.premium | premium }}
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="row">
                        <div class="col">
                            <h3 class="page-subheader">{{'OFFER_CONFIG.PAYMENTS' | translate}}</h3>
                        </div>
                        <div class="col-auto size-half-insurance h3 page-subheader">
                            <!--        Wysokość i termin płatności raty-->
                        </div>
                    </div>


                    <div class="row form-row">
                        <div class="col-auto size-property-col-1">
                            <app-output [label]="'INSTALLMENT_NUMBER' | translate">
                                {{ product.configuration.paymentDefinition.installments?.description}}
                            </app-output>
                        </div>

                        <div class="col-auto size-property-col-2">
                            <app-output [label]="'INSTALLMENT_POSTPONEMENT' | translate">
                                {{ product.configuration.paymentDefinition.deferredPayment?.description}}
                            </app-output>
                        </div>

                        <div class="col-auto size-half-insurance">
                            <div class="row" *ngIf="product.configuration.paymentDefinition.installmentList">
                                <div class="col-3"
                                     *ngFor="let element of product.configuration.paymentDefinition.installmentList">
                                    <!--                                            {{ 'OFFER_CONFIG.DATE_OF_PAYMENT' | translate }}-->
                                    <div class="inst">
                                        <div class="item-amount">{{ element.amount | premium }}</div>
                                        <div class="item-date">{{ element.date | lsnDate }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="separator"></div>

                    <hr/>

                    <div class="separator"></div>

                    <div class="row" *ngIf="product.configuration.premium !== null">
                        <div class="col">
                            {{ 'OFFER_CONFIG.TOTAL_PREMIUM' | translate }}
                        </div>
                        <div class="col-auto">
                            <div class="text-price">
                                <div class="item-price">
                                    {{ product.configuration.premium | premium }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn">
            <button (click)="close()"
                    class="btn btn-secondary"
                    type="button">{{ 'BUTTON.CLOSE' | translate }}</button>
        </div>
    </div>
</div>
